import { gql } from "lib/apolloClient";
import {
  plannerElementNodeFragment,
  pypElementFragment,
} from "UnitPlans/modules/UnitPlanFragments.js";

export const plannerElementSetFragment = {
  plannerElementSetWithNodes: gql`
    fragment plannerElementSetWithNodesItem on PlannerElementSet {
      id
      label
      type
      nodes(filters: $filters) {
        ...nonPypPlannerElementNodeItem
      }
    }
    ${plannerElementNodeFragment.nonPypPlannerElementNode}
  `,
};

export const plannerElementNodeSetFragment = {
  plannerElementNodeSetWithNodes: gql`
    fragment plannerElementNodeSetWithNodesItem on PlannerElementNodeSet {
      id
      plannerElementNodeSetWrapperV2 {
        ... on PlannerElementNodeSetWrapper {
          publishedData(filters: $plannerElementNodeFilters) {
            edges {
              node {
                ...nonPypPlannerElementNodeItem
              }
            }
          }
        }
        ... on PlannerATLSetWrapper {
          publishedData(filters: $plannerElementNodeFilters) {
            edges {
              node {
                ...atlItem
              }
            }
          }
        }
      }
    }
    ${pypElementFragment.atl}
    ${plannerElementNodeFragment.nonPypPlannerElementNode}
  `,
};
